import React from 'react';
import PropTypes from 'prop-types';
import {
  ResponsiveContainer,
  BarChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Bar,
} from 'recharts';
import { Box, Text } from 'grommet';

const PlatformBreakdownChart = ({
  data,
  primaryText = 'var(--page-primary-text)',
  secondaryText = 'var(--page-secondary-text)',
  subTitle = null,
  color = null,
  chartTooltip,
}) => (
  <Box direction="column" gap="1rem">
    <Box direction="column" gap="0.5rem">
      <Text color={primaryText} size="1rem" weight={700}>
        Platform Breakdown
      </Text>
      {subTitle && (
        <Text color={secondaryText} size="0.8rem" weight={400}>
          {subTitle}
        </Text>
      )}
    </Box>
    <Box height="19rem" width="100%">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} layout="vertical" margin={{ left: 10, right: 10 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#E6EEF6" />
          <XAxis type="number" tick={{ fill: '#5D738A', fontSize: 11 }} />
          <YAxis type="category" dataKey="platform" width={110} tick={{ fill: '#5D738A', fontSize: 11 }} />
          <Tooltip {...chartTooltip} formatter={(value) => [value, 'Infringements']} />
          <Bar dataKey="count" name="Infringements" fill={color || '#F59E0B'} radius={[0, 4, 4, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </Box>
  </Box>
);

PlatformBreakdownChart.propTypes = {
  data: PropTypes.array.isRequired,
  primaryText: PropTypes.string,
  secondaryText: PropTypes.string,
  subTitle: PropTypes.string,
  color: PropTypes.string,
  chartTooltip: PropTypes.object.isRequired,
};

export default PlatformBreakdownChart;
